{
  "title": "新手上路：平台管理員第一次使用指南",
  "description": "從取得 super_admin 權限到日常治理，快速了解平台管理員在 NAPAICP 上完整的第一次使用流程。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "讀完後，您會知道如何取得第一位 super_admin、平台主控台的四層分組架構、平時該看哪個頁面掌握平台整體治理狀態，以及與單一競賽管理有何不同。",
  "roleNote": "平台管理員（super_admin）",
  "prerequisites": [
    "已登入且完成 Email 驗證",
    "已取得 super_admin 全域角色（見下方「如何取得第一位 super_admin」）"
  ],
  "pathLabel": "/platform（僅 super_admin 可見）",
  "steps": [
    {
      "title": "1. 取得第一位 super_admin",
      "description": "系統初次部署、目前尚無任何啟用中 super_admin 時，才能透過受一次性 Bootstrap 憑證保護的流程建立第一位 super_admin；一旦平台已有啟用中 super_admin，後續授予新的 super_admin 一律由既有 super_admin 在「使用者」頁的「競賽與角色」分頁操作，不再走 Bootstrap 流程。"
    },
    {
      "title": "2. 認識平台主控台的四層分組",
      "description": "進入 /platform 後，左側導覽固定分為四層：平台總覽（總覽）、人員與權限（使用者、評審治理、管理員、帳號刪除申請）、競賽治理（競賽、競賽申請、探索分類）、安全與稽核（稽核紀錄）。此區塊不是第二套使用者／競賽／評審主資料，而是對權威資料的跨競賽治理視圖與操作入口。"
    },
    {
      "title": "3. 平時該看哪裡：平台總覽",
      "description": "「平台總覽」頁最上方是「需要你處理」卡片，彙整待審核的競賽申請件數、僅剩 1 位啟用中 super_admin 的風險提示等治理待辦；其下是「平台規模」與「治理狀態」兩組聚合指標卡片，每一項皆可點擊直接前往對應的篩選清單頁。"
    },
    {
      "title": "4. 審核競賽主辦申請",
      "description": "在「競賽治理」分組的「競賽申請」頁審核使用者提出的主辦申請；核准後伺服器會一次性自動建立正式競賽並將申請人設為第一位 competition_admin，此流程具冪等性，不會重複建立。"
    },
    {
      "title": "5. 管理使用者與評審治理",
      "description": "在「人員與權限」分組可搜尋使用者、查看各競賽角色摘要、授予或撤銷角色（撤銷需填寫原因，且不會刪除既有隊伍／評審關係的歷史紀錄），並處理跨競賽的評審治理事務。"
    },
    {
      "title": "6. 認識與單一競賽管理的邊界",
      "description": "平台管理員的治理範圍是跨競賽的使用者、競賽關係、評審治理與平台級稽核；單一競賽內部的設定、營運、資料、審查、權限管理，屬於該競賽 competition_admin 的職責範圍，平台管理員不會取代或繞過競賽層級的權限判斷。"
    }
  ],
  "afterward": [
    "您可以隨時回到「平台總覽」掌握目前平台整體治理狀態",
    "所有涉及使用者停權、角色授予撤銷、super_admin 異動的操作都會留下稽核紀錄，可在「安全與稽核」分組查詢",
    "系統任何時間都必須至少存在一位啟用中 super_admin，任何會讓這個數量降為零的操作都會被伺服器拒絕"
  ],
  "nextSteps": "完整規則、每個分組的詳細操作與各項限制，請見「操作手冊：平台管理」；平時想快速掌握平台整體治理現況，請見「平台總覽」相關說明。",
  "faq": [
    {
      "q": "我可以自己把自己設成 super_admin 嗎？",
      "a": "只有在平台目前完全沒有任何啟用中 super_admin 時，才能透過受保護的一次性 Bootstrap 流程建立第一位；此後任何新增 super_admin 的操作都必須由既有 super_admin 執行，不存在自行取得的管道。"
    },
    {
      "q": "平台管理員可以直接修改單一競賽的內部設定嗎？",
      "a": "不行。平台主控台是跨競賽治理視圖，不是第二套可寫的競賽資料來源；單一競賽的設定、營運與審查仍由該競賽的 competition_admin／staff 依其權限操作。"
    },
    {
      "q": "進入平台主控台後應該先看哪一頁？",
      "a": "建議先看「平台總覽」，一次掌握需要處理的治理待辦、平台規模與治理狀態指標；細部的使用者或競賽操作則在對應分組進行。"
    }
  ]
}
